import React from "react";
import { IRpgBackground } from "../../../models/IRpgBackground";

import "./BackgroundDetailsPanel.css";

interface IBackgroundDetailsPanelProps {
    background: IRpgBackground;
}

const BackgroundDetailsPanel: React.FC<IBackgroundDetailsPanelProps> = ({ background }) => {
    const hasSkillProficiencies = !!background.SkillProficiencies && background.SkillProficiencies.length > 0;
    const hasToolProficiencies = !!background.ToolProficiencies && background.ToolProficiencies.length > 0;
    const hasEquipmentProficiencies = !!background.EquipmentProficiencies && background.EquipmentProficiencies.length > 0;
    const hasLanguageProficiencies = !!background.LanguageProficiencies && background.LanguageProficiencies.length > 0;
    const hasBonusLanguages = !!background.BonusLanguages && background.BonusLanguages > 0;
    const hasStartingGoldBonus = !!background.StartingGoldBonus && background.StartingGoldBonus > 0;
    const hasFeatures = !!background.Features && background.Features.length > 0;

    return (
        <div className="bg-details">
            <h4 className="bg-details__title">{background.Name}</h4>

            <div className="bg-details__description">{background.Description}</div>

            <div className="bg-details__sections">
                {hasSkillProficiencies ? (
                    <div className="bg-details__section">
                        <div className="bg-details__sectionTitle">Skill Proficiencies</div>
                        <div className="bg-details__sectionBody">{background.SkillProficiencies!.join(", ")}</div>
                    </div>
                ) : null}

                {hasToolProficiencies ? (
                    <div className="bg-details__section">
                        <div className="bg-details__sectionTitle">Tool Proficiencies</div>
                        <div className="bg-details__sectionBody">{background.ToolProficiencies!.join(", ")}</div>
                    </div>
                ) : null}

                {hasEquipmentProficiencies ? (
                    <div className="bg-details__section">
                        <div className="bg-details__sectionTitle">Equipment Proficiencies</div>
                        <div className="bg-details__sectionBody">{background.EquipmentProficiencies!.join(", ")}</div>
                    </div>
                ) : null}

                {hasLanguageProficiencies ? (
                    <div className="bg-details__section">
                        <div className="bg-details__sectionTitle">Languages</div>
                        <div className="bg-details__sectionBody">{background.LanguageProficiencies!.join(", ")}</div>
                    </div>
                ) : null}

                {hasBonusLanguages ? (
                    <div className="bg-details__section">
                        <div className="bg-details__sectionTitle">Bonus Languages</div>
                        <div className="bg-details__sectionBody">{background.BonusLanguages}</div>
                    </div>
                ) : null}

                {hasStartingGoldBonus ? (
                    <div className="bg-details__section">
                        <div className="bg-details__sectionTitle">Starting Gold Bonus</div>
                        <div className="bg-details__sectionBody">{background.StartingGoldBonus}</div>
                    </div>
                ) : null}

                {hasFeatures ? (
                    <div className="bg-details__section">
                        <div className="bg-details__sectionTitle">Features</div>
                        <ul className="bg-details__list">
                            {background.Features!.map((feature) => (
                                <li key={feature}>{feature}</li>
                            ))}
                        </ul>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default BackgroundDetailsPanel;
